var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"training_center"},[_vm._v(" 培训中心 ")])}
var staticRenderFns = []

export { render, staticRenderFns }